import React from 'react';
import data from '../../ourDoctors.json';

const { doctorPhilosophy } = data;

const DoctorPhilosophy = () => {
  const {
    id,
    sectionLabel,
    quoteIcon,
    mainQuote,
    supportingText,
    pillars,
  } = doctorPhilosophy;

  return (
    <section id={id} className="w-full bg-white ava-section-gap">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-6xl mx-auto flex flex-col items-center">

          {/* ── Large watermark label — OUR PHILOSOPHY ── */}
          <div className="w-full relative mb-4">
            <span
              className="select-none font-black tracking-widest uppercase leading-none"
              style={{
                color: 'var(--gray-200)',
                fontSize: 'clamp(1.2rem, 5vw, 3.5rem)',
                letterSpacing: '0.12em',
              }}
            >
              {sectionLabel}
            </span>
          </div>

          {/* ── Quote icon (") ── */}
          <div className="w-full flex justify-center">
            <span
              className="font-serif select-none"
              style={{
                color: 'var(--gray-300)',
                fontSize: 'clamp(3rem, 6vw, 5rem)',
                lineHeight: 1,
              }}
              aria-hidden
            >
              &#x201D;
            </span>
          </div>

          {/* ── Main bold quote ── */}
          <blockquote
            className="text-center  mb-6 ava-heading-md"
            style={{
              // fontSize: 'clamp(1rem, 2.2vw, 1.35rem)',
              maxWidth: '850px',
            }}
          >
            {mainQuote}
          </blockquote>

          {/* ── Supporting paragraph ── */}
          <p
            className="text-center  mb-10 ava-text-body"
            style={{
              maxWidth: '700px',
            }}
          >
            {supportingText}
          </p>

          {/* ── Pillars row ── */}
          {pillars && pillars.length > 0 && (
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              {pillars.map((pillar) => (
                <div key={pillar.id} className="flex items-center gap-2">
                  {/* Filled dot */}
                  <span
                    className="w-2 h-2 rounded-full flex-shrink-0"
                    style={{ backgroundColor: 'var(--ava-color-body)' }}
                  />
                  <span
                    className="ava-text-body"
                  >
                    {pillar.label}
                  </span>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default DoctorPhilosophy;